/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_V2_Web_Page_HintInputs */

const en_home_v2_web_page_hint = /** @type {(inputs: Home_V2_Web_Page_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste any article link`)
};

const es_home_v2_web_page_hint = /** @type {(inputs: Home_V2_Web_Page_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega el enlace de cualquier artículo`)
};

/**
* | output |
* | --- |
* | "Paste any article link" |
*
* @param {Home_V2_Web_Page_HintInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const home_v2_web_page_hint = /** @type {((inputs?: Home_V2_Web_Page_HintInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_V2_Web_Page_HintInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_v2_web_page_hint(inputs)
	return en_home_v2_web_page_hint(inputs)
});